import * as React from 'react';
import { preparePagination } from '../utils/preparePagination';
export function usePagination(_ref) {
  var currentPage = _ref.currentPage,
    lastPage = _ref.lastPage;
  var pages = React.useMemo(function () {
    return preparePagination({
      currentPage: currentPage,
      totalPages: lastPage
    });
  }, [currentPage, lastPage]);
  var isPrevButtonEnabled = React.useMemo(function () {
    return currentPage > 1;
  }, [currentPage]);
  var isNextButtonEnabled = React.useMemo(function () {
    return currentPage < lastPage;
  }, [currentPage, lastPage]);
  return {
    pages: pages,
    isPrevButtonEnabled: isPrevButtonEnabled,
    isNextButtonEnabled: isNextButtonEnabled
  };
}